import { useQuery } from "@tanstack/react-query";
import { ApiServiceErr, axiosApi } from "./apiService";

export interface RecipeResult {
  _id?: string;
  requestId: string;
  recipeId: string;
  recipeName: string;
  originalRecipeImpactBreakdown: Record<string, any>;
  originalRecipetotalImpacts: Record<string, any>;
  variantstotalImpacts: Record<string, any>[];
  errors?: Record<string, any> | null;
  warnings?: Record<string, any> | null;
}

export const useGetRecipeResultsByRecipeId = (recipeId: string | undefined) =>
  useQuery<RecipeResult | null, ApiServiceErr>(
    ["recipeResults", recipeId],
    async () => {
      const response = await axiosApi.get(`/recipe-results/recipe/${recipeId}`);
      return response.data || null;
    },
    {
      enabled: !!recipeId,
      cacheTime: 0
    }
  );

export const useGetLatestRecipeResultByRecipeId = (recipeId: string | undefined) =>
  useQuery<RecipeResult | null, ApiServiceErr>(
    ["latestRecipeResult", recipeId],
    async () => {
      if (!recipeId) return null;
      const response = await axiosApi.get(`/recipe-results/by-recipe-id/${recipeId}`);
      const results = response.data || [];
      return results.length > 0 ? results[0] : null;
    },
    {
      enabled: !!recipeId,
      cacheTime: 0
    }
  );
